import {Tabs, TabsList, TabsTrigger} from "@/components/ui/tabs";

export type SearchMode = 'user' | 'chip';

interface SearchModeToggleProps {
    mode: SearchMode;
    onChange: (mode: SearchMode) => void;
    disabled?: boolean;
}

// בורר מצב חיפוש: חיפוש משתמש / חיפוש כרטיס.
export function SearchModeToggle({mode, onChange, disabled}: SearchModeToggleProps) {
    return (
        <Tabs value={mode} onValueChange={(value) => onChange(value as SearchMode)}>
            <TabsList>
                <TabsTrigger value="user" disabled={disabled} className="text-base">
                    חיפוש משתמש
                </TabsTrigger>
                <TabsTrigger value="chip" disabled={disabled} className="text-base">
                    חיפוש כרטיס
                </TabsTrigger>
            </TabsList>
        </Tabs>
    );
}
